/* Small visible chip marking illustrative content the owner should replace. */
export const SampleTag = ({ className = "" }) => (
    <span
        data-testid="sample-tag"
        className={`inline-block border border-brass px-2 py-0.5 text-[10px] font-medium uppercase tracking-widest text-brass ${className}`}
    >
        Sample
    </span>
);
